import { Component } from '@angular/core';
import { AuthService } from './modules/core/services/auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pr-to-po-client';

  constructor(private _authService: AuthService,
    private _router: Router){
      this._router.events.pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
    .subscribe(async event => {
      if (
        event.id === 1 &&
        event.url === event.urlAfterRedirects
      ) {
          // Your code here for when the page is refreshed
          const token = localStorage.getItem('ACCESS_TOKEN');
          token?this._authService.refreshToken(token):'';
          };
        })
     
    }
}
